import React, { useEffect } from "react";
import { range } from "range";
import { GroupMember, Product } from "~/common/Store/models/ProductListing";
import { cls } from "cls";
import {
  Select,
  SelectItem,
  SelectSeparator,
} from "@clarkinc/zest-design-system/ui";

export const incrementCount = 16;

interface QuantityDropdown {
  handleQuantityChange: (value: string) => void;
  product: Product;
  grouping: boolean;
  lastQuantityInterval: number;
  quantity: string;
  forceCustomQuantity: boolean;
  handleAddToCart: (event: React.SyntheticEvent) => void;
  selectedGroupMember: false | "" | GroupMember | undefined;
  mustPurchaseMoreThanOne: boolean;
  startBuy: number;
  mustBuy: number;
  isCompareWithProductBox?: boolean;
  productListingView?: string;
  undoBtnContainerStyle?: boolean;
}

const QuantityDropdown = ({
  handleQuantityChange,
  lastQuantityInterval,
  quantity,
  forceCustomQuantity,
  handleAddToCart,
  selectedGroupMember,
  mustPurchaseMoreThanOne,
  startBuy,
  mustBuy,
  isCompareWithProductBox,
  productListingView,
  undoBtnContainerStyle,
}: QuantityDropdown) => {
  const handleQuantityChanged = ({
    target: { value },
  }: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) =>
    handleQuantityChange(value);

  useEffect(() => {
    handleQuantityChange(startBuy.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupMember]);

  let increments = mustPurchaseMoreThanOne
    ? range(0, incrementCount).map((index) => startBuy + index * mustBuy)
    : [];

  if (selectedGroupMember && selectedGroupMember.mustPurchaseMoreThanOne) {
    increments = range(0, incrementCount).map(
      (index) =>
        selectedGroupMember.startBuy + index * selectedGroupMember.mustBuy,
    );
  }

  return (
    <div
      className={cls(
        "cartAndQuantity",
        undoBtnContainerStyle && productListingView === "grid" && "-ml-[30px]",
        isCompareWithProductBox && "text-left",
      )}
    >
      <span className="sr-only" id="select-other-callout">
        selecting other will provide a text input
      </span>

      {!forceCustomQuantity && (
        <Select
          label="Quantity"
          theme="wss"
          hideLabel={true}
          value={quantity}
          inputSize="small"
          onValueChange={(value) => {
            // Prevent form submission when "Other" is selected
            if (value === lastQuantityInterval.toString()) {
              // Use setTimeout to prevent immediate form submission
              setTimeout(() => {
                handleQuantityChange(value);
              }, 0);
            } else {
              handleQuantityChange(value);
            }
          }}
          name="qty"
          data-testid="dropDownCartQty"
          className="mb-2"
        >
          {range(1, incrementCount).map((i) => {
            const incrementValue = increments[i - 1];
            return incrementValue !== undefined ? (
              <SelectItem key={i} value={incrementValue.toString()}>
                {incrementValue}
              </SelectItem>
            ) : null;
          })}
          <SelectSeparator />
          <SelectItem value={lastQuantityInterval.toString()}>Other</SelectItem>
        </Select>
      )}

      <input
        className="add_qty quantity"
        aria-label="quantity"
        min="1"
        name="qty"
        type="number"
        onChange={handleQuantityChanged}
        value={quantity}
        hidden={!forceCustomQuantity}
        data-testid="itemAddCartQty"
      />
      <input
        type="submit"
        className="btn btn-cart btn-small"
        name="addToCartButton"
        value="Add to Cart"
        onClick={handleAddToCart}
        data-testid="itemAddCart"
        data-action="addToCart"
      />
    </div>
  );
};

export default QuantityDropdown;
